/**
 * Microservice names used in the application
 */
export enum Microservice {
  IAM = 'iam',
  ETICKETING = 'eticketing',
  CRM = 'crm',
  ECOMMERCE = 'ecommerce',
  MERCHANTS = 'merchants',
  ORGANISERS = 'organisers-module',
}

